'use strict';exports.__esModule = true;exports.companyNameValidation = exports.licenseNumberValidation = exports.phoneCodeCountyRegexValidation = exports.phoneRegexValidation = exports.passwordValidation = undefined;exports.

emailRegexValidation = emailRegexValidation;var _constants = require('../constants');function emailRegexValidation(email) {
  var emailRegex = /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;
  return emailRegex.test(email);
}

var passwordValidation = exports.passwordValidation = function passwordValidation(password) {return password.length >= 6 && password.length <= 20;};

var phoneRegexValidation = exports.phoneRegexValidation = function phoneRegexValidation(phone) {return _constants.phoneNumberRegex.test(phone);};
var phoneCodeCountyRegexValidation = exports.phoneCodeCountyRegexValidation = function phoneCodeCountyRegexValidation(phone) {return _constants.phoneСodeCountryRegex.test(phone);};

var licenseNumberValidation = exports.licenseNumberValidation = function licenseNumberValidation() {var license = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';return license.length >= 4 && license.length <= 9;};

var companyNameValidation = exports.companyNameValidation = function companyNameValidation() {var companyName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';return !!companyName.length;};


//////////////////
// WEBPACK FOOTER
// ./src/utils/validate.js
// module id = 48
// module chunks = 0